const variant = (
	`{
		id
		title
		priceV2 {
			amount
			currencyCode
		}
		compareAtPriceV2 {
			amount
			currencyCode
		}
		weight
		availableForSale
		sku
		product {
			id
			title
		}
		selectedOptions {
			name
			value
		}
	}`
);

const cart = (
	`{
		id
		createdAt
		updatedAt
		lines(first: 50) {
			edges {
				node {
					id
					quantity
					attributes {
						key
						value
					}
					merchandise {
						... on ProductVariant ${variant}
					}
				}
			}
		}
		cost {
			subtotalAmount {
				amount
				currencyCode
			}
			subtotalAmountEstimated
			totalAmount {
				amount
				currencyCode
			}
			totalAmountEstimated
			totalDutyAmount {
				amount
				currencyCode
			}
			totalDutyAmountEstimated
			totalTaxAmount {
				amount
				currencyCode
			}
			totalTaxAmountEstimated
		}
		checkoutUrl
		totalQuantity
		attributes {
			key
			value
		}
	}`
);


export default cart;
